import type {
	actOnPaymentInput,
	createPaymentInput,
	getAllPaymentsInput,
	getPaymentsFacetsInput,
	getUserPaymentInformationInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface Keys {
	usePayments: getAllPaymentsInput;
	usePaymentsFacets: getPaymentsFacetsInput;
	useCreatePayment: createPaymentInput;
	useActOnPayment: actOnPaymentInput;
	useGetUserPaymentInfo: getUserPaymentInformationInput;
	useGetEurUsdRate: undefined;
}

const PAYMENT_SERVICE_KEYS = createReactQueryKeys<Keys>("payment", [
	"usePayments",
	"usePaymentsFacets",
	"useCreatePayment",
	"useActOnPayment",
	"useGetUserPaymentInfo",
	"useGetEurUsdRate",
]);

export { PAYMENT_SERVICE_KEYS };
